var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9 5.91 2.29-2.29L12.71 5 8 9.74 3.29 5l1.42-1.38L7 5.91V1h2v4.91ZM13 12V9h2v5H1V9h2v3h10Z",
    fill: "#fff",
    fillRule: "nonzero"
  })));
};
export default SvgError;